@if (showProgressBar()) {
  <section class="w-full block absolute top-0 z-50">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </section>
}
<router-outlet></router-outlet>
<router-outlet name="modal"></router-outlet>
